import React from 'react';
import { useAdmin } from '../contexts/AdminContext';
import { ShieldCheck, X } from 'lucide-react';
import { Button } from './ui/button';

const AdminBadge = () => {
  const { isAdmin, logout } = useAdmin();

  if (!isAdmin) return null;

  return (
    <div data-testid="admin-mode-badge" className="fixed bottom-6 right-6 bg-slate-900 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 z-50 animate-in fade-in zoom-in-95 duration-300">
      <ShieldCheck className="w-4 h-4" />
      <span className="text-sm font-medium">Admin Mode Active</span>
      <button
        data-testid="admin-logout-button"
        onClick={logout}
        className="ml-2 hover:bg-white/20 rounded p-1 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AdminBadge;